import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Link } from 'react-router-dom'
import bannerImg1 from 'images/tmp_banner_image01.png'
import styles from './index.module.css'

const Setting = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: <span className="link-top">회원 탈퇴</span>
		})

		App.setShowNav(false)
		App.setMainClass("white")
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="visual-area pt_30">
					<p className="title">
						김모니님!<br />
						<strong>서비스이용에 꼭 필요한</strong><br />
						내용만 모았어요!
					</p>
					<div className={`${styles["btn-group"]} mt_30`}>
						<Link to="myInfoModify">내 정보 변경</Link>
						<Link to="certiMenu">인증/보안</Link>
					</div>
					<div className={styles["setting-object"]}></div>
				</div>
			</div>
			<div className="shadow">
				<div className="padding">
					<div className="flex-justify_between align_center">
						<div className="flex-align_center">
							<h3>이벤트</h3>
							<span className={`${styles.badge} ml_5`}>N</span>
						</div>
						<Link to="event">
							<i className="icon_arrow_sm icon_arrow_md right" />
						</Link>
					</div>
					<span className={`${styles["title-guide"]} mt_20`}>진행중인 이벤트의 빵빵한 혜택<br />놓치지 않을거에요!</span>
					<div className="slider mt_20">
						<ul className={styles["event-banner"]}>
							<li>
								<div className="img-box">
									<img src={bannerImg1} alt="" />
								</div>
							</li>
						</ul>
						<ul className="slider-dots dots-gray mt_20">
							<li className="active" />
							<li />
							<li />
						</ul>
					</div>
				</div>
			</div>
			<div className="shadow">
				<div className="padding">
					<h3>기타 서비스</h3>
					<ul className={`${styles["service-menu"]} mt_30`}>
						<li>
							<Link to="notice">
								<i className={`${styles["icon_service01"]} ${styles["icon_service"]} icon`} />
								<p>공지사항</p>
								<span className={styles.badge}>N</span>
							</Link>
						</li>
						<li>
							<Link to="faq">
								<i className={`${styles["icon_service02"]} ${styles["icon_service"]} icon`} />
								<p>FAQ</p>
							</Link>
						</li>
						<li>
							<Link to="question">
								<i className={`${styles["icon_service03"]} ${styles["icon_service"]} icon`} />
								<p>문의하기</p>
								<span className={styles.badge}>N</span>
							</Link>
						</li>
						<li>
							<Link to="alarmSetting">
								<i className={`${styles["icon_service04"]} ${styles["icon_service"]} icon`} />
								<p>알림설정</p>
							</Link>
						</li>
						<li>
							<Link to="termsAgree">
								<i className={`${styles["icon_service05"]} ${styles["icon_service"]} icon`} />
								<p>약관/동의</p>
							</Link>
						</li>
						<li>
							<Link to="appVer">
								<i className={`${styles["icon_service06"]} ${styles["icon_service"]} icon`} />
								<p>앱버전</p>
								<span className={styles.badge}>N</span>
							</Link>
						</li>
					</ul>
				</div>
			</div>
			<div className="padding">
				<h3>더 많은 정보를 확인해보세요!</h3>
				<ul className={`${styles["service-menu"]} mt_30`}>
					<li>
						<span className={styles.serviceSpan}>
							<i className={`${styles["logo_fintech"]} icon`} />
							<p>핀테크</p>
						</span>
					</li>
					<li>
						<span className={styles.serviceSpan}>
							<i className={`${styles["logo_moneey"]} icon`} />
							<p>모니</p>
						</span>
					</li>
					<li>
						<span className={styles.serviceSpan}>
							<i className={`${styles["logo_youtube"]} icon`} />
							<p>유튜브</p>
						</span>
					</li>
				</ul>
			</div>
		</div>
	)
}

export default Setting
